import { render, staticRenderFns } from "./GridId.vue?vue&type=template&id=194d6050&scoped=true&"
import script from "./GridId.vue?vue&type=script&lang=js&"
export * from "./GridId.vue?vue&type=script&lang=js&"
import style0 from "./GridId.vue?vue&type=style&index=0&id=194d6050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194d6050",
  null
  
)

export default component.exports